module.exports = __webpack_public_path__ + "img/dick2_slide_1.58b9b75a.jpg";